import { toAbsoluteUrl } from "_metronic/_helpers";
import React, { useState, useEffect } from "react";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import Spinner from "app/popleads/components/ui-kit/Spinner";
import { InputWrapper, Overlay, StyledDropdownItem, StyledDropdownMenu } from "../ExtensionHome";
import useSetProfileKeyContact from "app/popleads/hooks/useSetProfileKeyContact";
import useSetProfileFollowOption from "app/popleads/hooks/useSetProfileFollowOption";
import ExtensionSearch from "./ExtensionSearch";
import styled from "styled-components";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import SVG from "react-inlinesvg";
import useProfilKaydet from "app/popleads/hooks/useProfilKaydet";
import { useExtensionContext } from "../ExtensionContext";
import { colors } from "app/popleads/components/ui-kit/colors";
import ExtensionFullSizeDropdown from "./ExtensionFullSizeDropdown";
import useUpdateProfilFromSuggestions from "app/popleads/hooks/useUpdateProfilFromSuggestions";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { nameTag, silentlyParseJSON } from "app/popleads/app/functions/util";
import { useSelector } from "react-redux";
import FeatherIcon from "feather-icons-react";
import { StyledNameTag } from "./ExtensionViewDeal";
import { CompanyIcon } from "./ExtensionNewDealPage";
// import { Link } from "react-router-dom/cjs/react-router-dom";
import { MoveOption } from "app/popleads/modules/extension/components/SelectableTaskCard";
import { POPUP_CONTENTS } from "../utils/constants";

const ExtensionHeaderContent = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-self: center;
`;
const ExtensionHeader = styled.div`
    width: 100%;
    height: ${({ height }) => height}px;
    background-color: #fff;
    padding: 8px 12px;
    border-radius: 8px 8px 0 0;
    border-bottom: 1px solid ${colors.neutral[100]};
`;

const ExtensionHeaderLogo = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    height: 30px;
    align-items: center;
`;

const ExtensionHeaderIcons = styled.div`
    width: 100%;
    height: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 6px;
`;

const StyledSVGWrapper = styled.div`
    cursor: pointer;
`;
const StyledProfileNameTag = styled(StyledNameTag)`
    width: 28px;
    height: 28px;
    cursor: pointer;
`;
const StyledProfilePic = styled(CompanyIcon)`
    width: 28px;
    height: 28px;
    cursor: pointer;
`;

const StyledDropdown = styled(Dropdown)`
    height: 28px !important;
    width: 28px !important;
`;

const ProfileWrapper = styled.div`
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
`;

const StyledProfileDropdownToggle = styled(Dropdown.Toggle)`
    background: none !important;
    border: none !important;
    padding: 0 !important;
    color: inherit !important;
    box-shadow: none !important;
    height: 28px !important;
    width: 28px !important;
    min-width: 28px !important;
    max-width: 28px !important;
    border-radius: 0px !important;

    &:hover,
    &:active,
    &:focus {
        background: none !important;
        border: none !important;
        box-shadow: none !important;
        color: inherit !important;
    }

    &:after {
        display: none !important;
    }
`;

const THIRTY_DAYS_IN_MS = 30 * 24 * 60 * 60 * 1000;

const ExtensionHeaderActions = ({
    isSearchVisible,
    toggleSearch,
    searchInputOptionClick,
    setIsPopitSearch,
    setIsDeleteModalOpen,
    headerHeight,
    isPopitSearch,
}) => {
    const { user: loggedInUser } = useSelector((state) => state.auth);
    const { setProfileKeyContact } = useSetProfileKeyContact();
    const { setProfileFollowOption } = useSetProfileFollowOption();
    const {
        profile,
        popit,
        urlParams,
        getEsListe,
        profilListeLoading,
        newLeadObject,
        profilListe,
        setState,
        selectedTab,
        setProfile,
        isIframeOpen,
        refetchProfile,
    } = useExtensionContext();
    const keyContactText =
        profile?.keyContactStatus === 2 || profile?.keyContactStatus === 3 ? "Remove Key Contact" : "Key Contact";

    const now = Date.now();
    const lastNoteTime = profile?.lastNoteTime;
    const diff = Math.abs(now - lastNoteTime);

    const profileColor =
        lastNoteTime && diff < THIRTY_DAYS_IN_MS
            ? "#f1e767"
            : profile?.kategori === "lead"
            ? colors.success[700]
            : profile?.kategori === "contact"
            ? colors.warning[700]
            : colors.primary[700];
    const { updateProfilFromSuggestions } = useUpdateProfilFromSuggestions();
    const { profilKaydet } = useProfilKaydet();
    const history = useHistory();
    const [isIframeLoading, setIsIframeLoading] = useState(true);
    const [hasImageError, setHasImageError] = useState(false);
    const iframeRef = React.useRef(null);
    // const url_params = new URLSearchParams(window.location.search);
    //const extParam = url_params.get("ext");

    const devUrl = "https://dev.popleads.com/PopleadsDevCRM1/";
    const hostname = window.location.hostname;
    const subdomain = hostname.split(".")[0];
    const baseName = subdomain.includes("dev-crm-")
        ? `dev.popleads.com/PopleadsDevCRM${subdomain[subdomain.length - 1]}`
        : "secure.popleads.com/Xpider";
    const newIframeUrl = hostname !== "localhost" ? `https://${baseName}/` : devUrl;

    const handleMinimizeClick = () => {
        setState((prevState) => ({
            ...prevState,
            isIframeOpen: true,
        }));
        setIsIframeLoading(true);
    };

    const handleCloseIframe = () => {
        setState((prevState) => ({
            ...prevState,
            isIframeOpen: false,
        }));

        window.parent.postMessage(
            {
                message: "XPIDER_MESSAGE_IFRAME_WIDTH",
                width: 300,
            },
            "*"
        );
    };

    const handleIframeLoad = () => {
        setIsIframeLoading(false);
    };
    const { user } = useSelector((state) => state.auth);

    useEffect(() => {
        const dnsPrefetch = document.createElement("link");
        dnsPrefetch.rel = "dns-prefetch";
        dnsPrefetch.href = "https://secure.popleads.com";
        document.head.appendChild(dnsPrefetch);

        const preconnect = document.createElement("link");
        preconnect.rel = "preconnect";
        preconnect.href = "https://secure.popleads.com";
        document.head.appendChild(preconnect);

        const preload = document.createElement("link");
        preload.rel = "preload";
        preload.href = "https://secure.popleads.com/Xpider/";
        preload.as = "document";
        document.head.appendChild(preload);

        return () => {
            document.head.removeChild(dnsPrefetch);
            document.head.removeChild(preconnect);
            document.head.removeChild(preload);
        };
    }, []);

    const rawLinkedinUrl = urlParams?.profil_url?.replace(/\/$/, "");
    const linkedinUrl = rawLinkedinUrl?.startsWith("https://www.linkedin.com/in/") ? rawLinkedinUrl : "";

    // Takip durumunu izleyen state
    const [followStatus, setFollowStatus] = useState(false);

    // Image error handler
    const handleImageError = () => {
        setHasImageError(true);
    };

    // User değiştiğinde hasImageError'u sıfırla
    useEffect(() => {
        setHasImageError(false);
    }, [user?.linkedinPicture]);

    // Profil değiştiğinde followStatus'u güncelle
    useEffect(() => {
        if (profile?.followerIds && loggedInUser?.id) {
            const followerIds = silentlyParseJSON(profile.followerIds, "[]");
            setFollowStatus(followerIds.includes(loggedInUser?.id));
        }
    }, [profile?.followerIds, loggedInUser?.id]);

    const handleSaveProfile = async (params, isManual = false) => {
        let requestObject = {};
        if (isManual) {
            requestObject = {
                ad: params?.ad,
                soyad: params?.soyad,
                tel: params?.tel,
                email: params?.email,
                city: params?.city,
                country: params?.country,
                sirket: params?.sirket,
                baslik: params?.baslik,
                kategori: params?.kategori,
            };
        } else {
            const nameAndSurname = params?.ad.split(" ");
            const name = nameAndSurname
                .slice(0, nameAndSurname.length - 1)
                .join(" ")
                .trim();
            const surname = nameAndSurname.length > 1 ? nameAndSurname[nameAndSurname.length - 1].trim() : "";

            const cityAndCountry = params?.ulke ? params?.ulke.split(", ") : [];
            const city =
                cityAndCountry.length > 1
                    ? cityAndCountry
                          .slice(0, cityAndCountry.length - 1)
                          .join(", ")
                          .trim()
                    : "";
            const country = cityAndCountry.length > 1 ? cityAndCountry[cityAndCountry.length - 1].trim() : params?.ulke;

            requestObject = {
                ad: name,
                soyad: surname,
                baslik: params.baslik,
                headline: params.headline,
                sirket: params.sirket,
                email: params.email,
                tel: params.tel,
                city: city,
                country: country,
                resim: params.resim,
                url: params.url,
                kategori: params.kategori ? params.kategori : "lead",
            };
        }

        const response = await profilKaydet(requestObject);
        if (response && response.profil.id) {
            if (isManual) {
                setState((prevState) => ({
                    ...prevState,
                    selectedTab: "Feed",
                }));
                window.open(`/extension?profileId=${response.profil.id}`, "_blank");
            } else if (linkedinUrl) {
                toast.success("Created new lead successfully");
                refetchProfile();
            } else {
                setState((prevState) => ({
                    ...prevState,
                    selectedTab: "Profile",
                }));
                toast.success("Created new lead successfully");
                history.push(`/extension?profileId=${response.profil.id}`);
            }
        }
    };

    const handlePopitResultClick = async (result) => {
        if (newLeadObject) {
            const response = await updateProfilFromSuggestions({
                id: result.id,
                isManual: 1,
                linkedin_profile_id: "",
                url: "",
                resim: "",
            });
            if (response && response.profil.id) {
                setIsPopitSearch(false);
                setState((prevState) => ({
                    ...prevState,
                    selectedTab: "Feed",
                }));
                window.open(`/extension?profileId=${response.profil.id}`, "_blank");
            }
        } else {
            const response = await updateProfilFromSuggestions({
                id: result.id,
                isManual: 0,
                linkedin_profile_id: "",
                url: urlParams?.profil_url || "",
                resim: urlParams?.profil_resim || "",
                headline: urlParams?.profil_headline || "",
            });
            if (response && response.profil.id) {
                setIsPopitSearch(false);
                refetchProfile();
            }
        }
    };

    const handleKeyContactClick = async () => {
        if (profile?.kategori === "lead") {
            toast.warning("Key-Contact status can not be added to Leads.");
            return;
        }
        const isKeyContactManager = loggedInUser?.permissions?.KEYCONTACT_MANAGER === 1;
        const option = profile?.keyContactStatus === 2 || profile?.keyContactStatus === 3 ? "disable" : "enable";
        const result = await setProfileKeyContact(option);
        if (result && result.data && result.data.profil) {
            setProfile((prevProfile) => ({
                ...prevProfile,
                keyContactStatus: result.data.profil.keyContactStatus,
            }));
            toast.success(
                isKeyContactManager
                    ? "Key-Contact status was successfully updated."
                    : "Key-Contact status was successfully sent for approval."
            );
        }
    };

    const handleCategoryToggleClick = async () => {
        if (!profile?.sirket) {
            toast.warning("You need to enter the company info for the profile.");
            return;
        }

        setState((prevState) => ({
            ...prevState,
            loading: true,
        }));

        try {
            const result = await profilKaydet({
                id: profile?.id,
                kategori: "contact",
                auto: "0",
                isManuel: "1",
            });

            if (result && result.profil) {
                setProfile((prevProfile) => ({
                    ...prevProfile,
                    kategori: "contact",
                }));
            }
        } finally {
            setState((prevState) => ({
                ...prevState,
                loading: false,
            }));
        }
    };

    return (
        <>
            {isIframeOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        zIndex: 9999,
                        backgroundColor: "#fff",
                    }}
                >
                    <div
                        style={{
                            position: "absolute",
                            bottom: "22px",
                            right: "2px",
                            zIndex: 10000,
                            cursor: "pointer",
                            padding: "6px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "50px",
                            height: "10px",
                        }}
                    >
                        <ButtonWithText
                            label="Close"
                            iconType={"material"}
                            variant="l3rnTech"
                            size="medium"
                            buttonStyle="default"
                            icon={"close_fullscreen"}
                            onClick={handleCloseIframe}
                        ></ButtonWithText>
                    </div>

                    {isIframeLoading && (
                        <div
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                zIndex: 9998,
                                textAlign: "center",
                            }}
                        >
                            <Spinner size={60} thickness={4} variant="l3rnTech" />
                            <div style={{ marginTop: "15px", fontSize: "16px" }}>Loading Popleads Xpider...</div>
                        </div>
                    )}

                    <iframe
                        ref={iframeRef}
                        src={newIframeUrl}
                        style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                            visibility: isIframeLoading ? "hidden" : "visible",
                        }}
                        allow="clipboard-write"
                        title="Popleads Xpider"
                        onLoad={handleIframeLoad}
                        loading="eager"
                        importance="high"
                    />
                </div>
            )}
            <ExtensionHeader height={headerHeight}>
                <ExtensionHeaderContent>
                    {isSearchVisible && (
                        <>
                            <Overlay onClick={toggleSearch} />
                            <InputWrapper>
                                <ExtensionSearch optionClick={searchInputOptionClick} />
                            </InputWrapper>
                        </>
                    )}
                    <>
                        <ExtensionHeaderLogo>
                            <a
                                href={popit ? "#" : profile?.id ? `/extension?profileId=${profile?.id}` : "/extension"}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <SVG src={toAbsoluteUrl("/media/l3rn-tech/L3RNTechBlack.svg")} height={16} />
                            </a>
                        </ExtensionHeaderLogo>
                        <ExtensionHeaderIcons>
                            {user?.permissions?.LEAD_AI_SUGGESTION_ACCESS === 1 && (
                                <StyledSVGWrapper>
                                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Certified AI Native</Tooltip>}>
                                        <ButtonWithText
                                            label="Certified AI Native"
                                            iconType="material"
                                            icon="auto_awesome"
                                            buttonStyle="borderless"
                                            variant={popit ? "passive" : "l3rnTech"}
                                            size="xsmall"
                                            materialIconStyle="material-icons"
                                            style={{
                                                fontSize: "20px",
                                            }}
                                            onClick={() => {
                                                setState((prevState) => ({
                                                    ...prevState,
                                                    popupContent: POPUP_CONTENTS.AI_ASSISTANT,
                                                    popupIsOpen: true,
                                                }));
                                            }}
                                        />
                                    </OverlayTrigger>
                                </StyledSVGWrapper>
                            )}
                            <StyledSVGWrapper>
                                <OverlayTrigger placement="bottom" overlay={<Tooltip>Search</Tooltip>}>
                                    <SVG
                                        height={16}
                                        src={toAbsoluteUrl("/media/svg/icons/Extension/search.svg")}
                                        onClick={toggleSearch}
                                    />
                                </OverlayTrigger>
                            </StyledSVGWrapper>
                            {selectedTab === "Profile" && popit ? (
                                <ButtonWithText
                                    loading={profilListeLoading && !newLeadObject}
                                    variant="l3rnTech"
                                    buttonStyle="default"
                                    type="default"
                                    size="small"
                                    onClick={() => {
                                        getEsListe(
                                            {
                                                fullName: urlParams?.profil_ad,
                                                baslik: urlParams?.profil_baslik,
                                                headline: urlParams?.profil_headline,
                                                sirket: urlParams?.profil_sirket,
                                                email: urlParams?.profil_email,
                                                email2: urlParams?.email2,
                                                tel: urlParams?.profil_tel,
                                                cityAndCountry: urlParams?.profil_ulke,
                                                resim: urlParams?.profil_resim,
                                                url: urlParams?.profil_url,
                                                kategori: urlParams?.kategori,
                                            },
                                            true
                                        ).then(() => {
                                            setIsPopitSearch(true);
                                        });
                                    }}
                                >
                                    Pop-It
                                </ButtonWithText>
                            ) : (
                                <>
                                    <StyledSVGWrapper>
                                        <OverlayTrigger placement="bottom" overlay={<Tooltip>Go to the CRM</Tooltip>}>
                                            <SVG
                                                src={toAbsoluteUrl("/media/svg/icons/Extension/keyboard_tap.svg")}
                                                onClick={handleMinimizeClick}
                                                height={16}
                                            />
                                        </OverlayTrigger>
                                    </StyledSVGWrapper>
                                    {profile && selectedTab === "Profile" && (
                                        <StyledSVGWrapper>
                                            <StyledDropdown>
                                                <StyledProfileDropdownToggle id="profile-actions-dropdown">
                                                    <OverlayTrigger
                                                        placement="bottom"
                                                        overlay={
                                                            <Tooltip className="text-capitalize">
                                                                {profile?.kategori}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>
                                                            {profile?.keyContactStatus > 1 ? (
                                                                <FeatherIcon icon="link" size={20} />
                                                            ) : (
                                                                <SVG
                                                                    style={{
                                                                        fill: profileColor,
                                                                        cursor: "pointer",
                                                                    }}
                                                                    src={toAbsoluteUrl(
                                                                        "/media/svg/icons/Extension/pop-it.svg"
                                                                    )}
                                                                    height={16}
                                                                />
                                                            )}
                                                        </span>
                                                    </OverlayTrigger>
                                                </StyledProfileDropdownToggle>
                                                <StyledDropdownMenu>
                                                    <StyledDropdownItem
                                                        onClick={handleCategoryToggleClick}
                                                        disabled={profile?.kategori === "contact"}
                                                    >
                                                        <SVG
                                                            height={16}
                                                            style={{
                                                                fill:
                                                                    profile?.kategori === "lead"
                                                                        ? `${colors.warning[700]}`
                                                                        : `${colors.success[700]}`,
                                                            }}
                                                            src={toAbsoluteUrl("/media/svg/icons/Extension/pop-it.svg")}
                                                        />
                                                        {profile?.kategori === "lead" ? "Contact" : "Lead"}
                                                    </StyledDropdownItem>

                                                    <StyledDropdownItem
                                                        onClick={async () => {
                                                            const currentStatus = followStatus;
                                                            const result = await setProfileFollowOption(
                                                                currentStatus ? "disable" : "enable"
                                                            );
                                                            if (result && result.success) {
                                                                setFollowStatus(!currentStatus);
                                                                const followerIds = silentlyParseJSON(
                                                                    profile?.followerIds,
                                                                    "[]"
                                                                );

                                                                const updatedFollowerIds = currentStatus
                                                                    ? followerIds.filter(
                                                                          (id) => id !== loggedInUser?.id
                                                                      )
                                                                    : [...followerIds, loggedInUser?.id];
                                                                setProfile((prevProfile) => ({
                                                                    ...prevProfile,
                                                                    followerIds: JSON.stringify(updatedFollowerIds),
                                                                }));
                                                            }
                                                        }}
                                                    >
                                                        <FeatherIcon icon="chevrons-right" size={16} />
                                                        {followStatus ? "Unfollow" : "Follow"}
                                                    </StyledDropdownItem>
                                                    <StyledDropdownItem onClick={handleKeyContactClick}>
                                                        <FeatherIcon icon="link" size={16} />
                                                        {keyContactText}
                                                    </StyledDropdownItem>
                                                </StyledDropdownMenu>
                                            </StyledDropdown>
                                        </StyledSVGWrapper>
                                    )}
                                </>
                            )}
                            {/* {profile && selectedTab === "Profile" && (
                                <StyledSVGWrapper>
                                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Delete this profile</Tooltip>}>
                                        <SVG
                                            src={toAbsoluteUrl("/media/svg/icons/Extension/delete.svg")}
                                            onClick={() => setIsDeleteModalOpen(true)}
                                        />
                                    </OverlayTrigger>
                                </StyledSVGWrapper>
                            )} */}
                            <StyledDropdown>
                                <StyledProfileDropdownToggle id="dropdown-user">
                                    <OverlayTrigger placement="bottom" overlay={<Tooltip>{user?.name}</Tooltip>}>
                                        <ProfileWrapper>
                                            {user?.linkedinPicture && !hasImageError ? (
                                                <StyledProfilePic
                                                    src={user?.linkedinPicture}
                                                    onError={handleImageError}
                                                />
                                            ) : (
                                                <StyledProfileNameTag>{nameTag(user?.name)}</StyledProfileNameTag>
                                            )}
                                        </ProfileWrapper>
                                    </OverlayTrigger>
                                </StyledProfileDropdownToggle>

                                <Dropdown.Menu style={{ width: "100px" }}>
                                    <span
                                        onClick={async () => {
                                            await setState({
                                                popupContent: null,
                                                popupIsOpen: false,
                                            });
                                            localStorage.setItem("prevUrl", window.location.href);
                                            window.location.href = "/logout";
                                        }}
                                    >
                                        <MoveOption>Sign Out </MoveOption>
                                    </span>
                                </Dropdown.Menu>
                            </StyledDropdown>
                        </ExtensionHeaderIcons>
                    </>
                </ExtensionHeaderContent>
            </ExtensionHeader>
            {isPopitSearch && profilListe?.profilListe.length > 0 && (
                <>
                    <Overlay onClick={toggleSearch} />
                    <InputWrapper>
                        <ExtensionFullSizeDropdown
                            title="WE FOUND THESE MATCHES"
                            isOpen={isPopitSearch}
                            options={profilListe?.profilListe || []}
                            searchText={
                                newLeadObject
                                    ? `${newLeadObject?.name} ${newLeadObject?.surname}`
                                    : urlParams?.profil_ad
                            }
                            handleResultClick={handlePopitResultClick}
                            setIsOpen={setIsPopitSearch}
                            footerComponent={
                                <ButtonWithText
                                    variant="l3rnTech"
                                    buttonStyle="default"
                                    onClick={() => {
                                        if (newLeadObject) {
                                            handleSaveProfile(
                                                {
                                                    ad: newLeadObject?.name,
                                                    soyad: newLeadObject?.surname,
                                                    tel: newLeadObject?.phone,
                                                    email: newLeadObject?.email,
                                                    city: newLeadObject?.city,
                                                    country: newLeadObject?.country,
                                                    sirket: newLeadObject?.account,
                                                    baslik: newLeadObject?.title,
                                                    kategori: newLeadObject?.kategori,
                                                },
                                                true
                                            );
                                        } else {
                                            handleSaveProfile({
                                                ad: urlParams?.profil_ad,
                                                baslik: urlParams?.profil_baslik,
                                                headline: urlParams?.profil_headline,
                                                sirket: urlParams?.profil_sirket,
                                                tel: urlParams?.profil_tel,
                                                email: urlParams?.profil_email,
                                                ulke: urlParams?.profil_ulke,
                                                resim: urlParams?.profil_resim,
                                                url: urlParams?.profil_url,
                                                kategori: urlParams?.kategori,
                                            });
                                        }
                                        setIsPopitSearch(false);
                                    }}
                                >
                                    None of Above? Create New Lead
                                </ButtonWithText>
                            }
                        />
                    </InputWrapper>
                </>
            )}
        </>
    );
};

export default ExtensionHeaderActions;
